import React, {useState, useCallback} from 'react';
import MacroDetails from './MacroDetails.js';

export default ({effect}) => {
    let total = 0;
    for (let m of effect.macros) {
        total += m.subMacros.length;
    }

    return (
        <div className="effect-details">
          {total === 0?
          <div className="macros-details-title">
            Macros
          </div> : ''}
          {total === 0 ? <div className="no-macros-text">You haven't set any macros yet.</div> : ''}
          {effect.macros
           .filter(macro => macro.subMacros.length > 0)
           .map(
            macro =>
                <MacroDetails macro={macro}/>)}
        </div>
    );
};

